export const resolveFileName = (file) => {
    if (!file) return "";
    if (typeof file === "string") return file;
    return file?.upload?.filename || file?.name || "";
};

export const getFileExtension = (fileName) => {
    if (!fileName) return "";
    const parts = fileName.split(".");
    return parts.length > 1 ? parts[parts.length - 1].toLowerCase() : "";
};

export const getFileIconClass = (fileName) => {
    const ext = getFileExtension(fileName);
    switch (ext) {
        case "pdf":
            return "pdf";
        case "xls":
        case "xlsx":
            return "excel";
        case "doc":
        case "docx":
            return "doc";
        case "ppt":
        case "pptx":
            return "ppt";
        case "png":
        case "jpg":
        case "jpeg":
        case "gif":
        case "svg":
        case "webp":
            return "image";
        default:
            return "generic";
    }
};
